import React from "react";
import { typeOf } from "@/lib/customers";

export function CustomerTypeBadge({ type, testid }) {
  const t = typeOf(type);
  if (!t) return <span className="text-slate-400 text-xs" data-testid={testid}>—</span>;
  return (
    <span data-testid={testid} className={`inline-block px-2 py-0.5 rounded-md border text-[11px] font-medium ${t.tone}`}>
      {t.label}
    </span>
  );
}
